import { render } from "./Footer.vue?vue&type=template&id=5790beeb"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/inc/Footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5790beeb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5790beeb', __exports__)) {
    api.reload('5790beeb', __exports__)
  }
  
  module.hot.accept("./Footer.vue?vue&type=template&id=5790beeb", () => {
    api.rerender('5790beeb', render)
  })

}


export default __exports__